import { useContext, useEffect, useState } from 'react';

import { useIsFocused } from '@react-navigation/native';
import { useRouter } from 'expo-router';

import { useRoute } from 'navigation/hooks';
import { AuthContext } from 'state/auth';
import { ModalAuthTrigger } from 'state/auth/types';
import { routes } from 'utils/routing';

interface IAuthRedirectsProps {
  skip?: boolean;
}

export default function useAuthRedirects({ skip = false }: IAuthRedirectsProps) {
  const {
    loading: isAuthLoading,
    isAuthenticated,
    originLocation,
    setOriginLocation,
    openSignInModal,
  } = useContext(AuthContext);

  const { replace } = useRouter();
  const { pathname: originRouteName, params } = useRoute<Record<string, any>>();
  const isFocused = useIsFocused();

  // required to avoid expo router errors of the below navigate()s happening to early in the app lifecycle on closed app deep link
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!isMounted || skip || isAuthLoading || !isFocused) {
      return;
    }

    if (!isAuthenticated) {
      const originLocationURLParams = new URLSearchParams(params).toString();
      const originLocationWithParams = `${originRouteName}${
        originLocationURLParams ? `?${originLocationURLParams}` : ''
      }`;

      replace(routes.base);

      openSignInModal({
        trigger: ModalAuthTrigger.Modal,
        navigateOnSuccessRoute: originLocationWithParams,
      });
    }
  }, [
    replace,
    isAuthenticated,
    isAuthLoading,
    originLocation,
    setOriginLocation,
    originRouteName,
    params,
    skip,
    isMounted,
    isFocused,
    openSignInModal,
  ]);
}
